import { ROUTE_NAMES } from './routeNames.const'

export const routeProtection = {
  path: '/protection/:stage?',
  name: ROUTE_NAMES.protection,
  component: () =>
    import(
      /* webpackChunkName: "Protection" */ 'src/pages/Protection/Protection.vue'
    ),
  props: true,
}
